import React from 'react';
import Bloger from '../blog/components/Bloger.js';
import { Link } from 'react-router-dom';
import '../gral-stylesheets/blog-box.scss';

import blogers from '../data/users/users-blog.json';



class BlogBox extends React.Component {
  render() {
    let options = blogers.slice(0, 3);
    return (
      <div className='blog-box-content-container'>
        <ul className='blog-box-content'>
          {
            options.map((user, index) => (
              <Bloger
                key={index}
                src={user.image}
                alt={user.alt}
                author={user.name}
                title={user.title}
                text={user.description}
                date={user.date}
                comments={user.comments}
                likes={user.likes}
              />
            ))
          }
        </ul>
        <div className='button-more-container'>
          <Link to='/blog'>
            <h3>More blog content</h3>
          </Link>
        </div>
      </div>
    )
  }
}

export default BlogBox;